export const QUERY_KEYS = {
  // Auth / profil
  GET_ME: "get-me",
  GET_PROFILE: "get-profile",
  GET_SESSIONS: "get-sessions",
  GET_HEALTH: "get-health",

  // Ma'lumotnoma
  GET_CATEGORIES: "get-categories",
  GET_CATEGORY: "get-category",
  GET_COURSE_LEVELS: "get-course-levels",
  GET_COURSE_LEVEL: "get-course-level",

  // Kurslar va kontent
  GET_COURSES: "get-courses",
  GET_COURSE: "get-course",
  GET_COURSE_READINESS: "get-course-readiness",
  GET_MY_COURSES: "get-my-courses",
  GET_LIVE_COURSES: "get-live-courses",
  GET_MY_LIVE_COURSES: "get-my-live-courses",
  GET_LIVE_SCHEDULE: "get-live-schedule",
  GET_LIVE_SESSIONS: "get-live-sessions",
  GET_LIVE_GRADING: "get-live-grading",
  GET_SESSION_HOMEWORK: "get-session-homework",
  GET_COURSE_JOURNAL: "get-course-journal",
  GET_MY_JOURNAL: "get-my-journal",
  GET_SESSION_ROSTER: "get-session-roster",
  GET_ATTENDANCE_SUMMARY: "get-attendance-summary",
  GET_MY_ATTENDANCE: "get-my-attendance",
  GET_GRADEBOOK: "get-gradebook",
  GET_MY_GRADE: "get-my-grade",
  GET_PENDING_COURSES: "get-pending-courses",
  GET_MODERATION_STATS: "get-moderation-stats",
  GET_MODERATION_LIST: "get-moderation-list",

  // Yozilishlar
  GET_MY_ENROLLMENTS: "get-my-enrollments",
  GET_MY_ENROLLMENT_STATUS: "get-my-enrollment-status",
  GET_COURSE_ROSTER: "get-course-roster",
  GET_ENROLLMENT_STATS: "get-enrollment-stats",
  GET_COURSE_REMOVALS: "get-course-removals",
  GET_REMOVALS: "get-removals",
  GET_FINISH_PREVIEW: "get-finish-preview",

  // Sharhlar / o'qituvchi profili
  GET_COURSE_REVIEWS: "get-course-reviews",
  GET_MY_REVIEW: "get-my-review",
  GET_TEACHER_PROFILE: "get-teacher-profile",
  GET_REVIEW_MODERATION_STATS: "get-review-moderation-stats",
  GET_REVIEW_MODERATION_LIST: "get-review-moderation-list",

  // Postlar (yangiliklar / bloglar)
  GET_NEWS: "get-news",
  GET_NEWS_ONE: "get-news-one",
  GET_BLOGS: "get-blogs",
  GET_BLOG_ONE: "get-blog-one",
  GET_POST_CATEGORIES: "get-post-categories",
  GET_MY_POSTS: "get-my-posts",
  GET_POST: "get-post",
  GET_POST_MODERATION_STATS: "get-post-moderation-stats",
  GET_POST_MODERATION_LIST: "get-post-moderation-list",
  GET_POST_COMMENTS: "get-post-comments",
  GET_POST_LIKES: "get-post-likes",

  // Bildirishnomalar
  GET_NOTIFICATIONS: "get-notifications",
  GET_NOTIFICATIONS_UNREAD: "get-notifications-unread",

  // Progress / test urinishlari / topshiriqlar
  GET_COURSE_PROGRESS: "get-course-progress",
  GET_BEST_ATTEMPT: "get-best-attempt",
  GET_MY_SUBMISSION: "get-my-submission",
  GET_ASSIGNMENT_SUBMISSIONS: "get-assignment-submissions",
  GET_SUBMISSION: "get-submission",
  GET_QUIZ_ATTEMPTS: "get-quiz-attempts",
  GET_QUIZ_PENDING_GRADING: "get-quiz-pending-grading",
  GET_ATTEMPT_RESULT: "get-attempt-result",
  GET_MY_ATTEMPT_REQUEST: "get-my-attempt-request",
  GET_ATTEMPT_REQUESTS: "get-attempt-requests",
  GET_SECTIONS: "get-sections",
  GET_LESSONS: "get-lessons",
  GET_LESSON: "get-lesson",
  GET_LECTURE: "get-lecture",
  GET_READING: "get-reading",
  GET_QUIZ: "get-quiz",
  GET_QUIZ_QUESTIONS: "get-quiz-questions",
  GET_ASSIGNMENT: "get-assignment",

  // Foydalanuvchilar / o'qituvchilik arizalari
  GET_USERS: "get-users",
  GET_USER: "get-user",
  GET_TEACHER_REQUESTS: "get-teacher-requests",
  GET_MY_TEACHER_REQUESTS: "get-my-teacher-requests",
  GET_TEACHER_REQUEST: "get-teacher-request",
  GET_ANNOUNCEMENTS: "get-announcements",
  GET_AUDIENCE_COUNTS: "get-audience-counts",
  GET_MY_CERTIFICATES: "get-my-certificates",
  GET_MY_CERTIFICATE: "get-my-certificate",
  VERIFY_CERTIFICATE: "verify-certificate",

  // Sevimlilar
  GET_WISHLIST: "get-wishlist",
  GET_WISHLIST_IDS: "get-wishlist-ids",
  GET_WISHLIST_HAS: "get-wishlist-has",

  // Kurs izohlari
  GET_COURSE_COMMENTS: "get-course-comments",

  // To'lovlar
  GET_MY_PAYMENTS: "get-my-payments",
  GET_COURSE_PAYMENTS: "get-course-payments",
  GET_PAYMENT_LEDGER: "get-payment-ledger",
  GET_CARD_REVIEW: "get-card-review",
  GET_CARD_HISTORY: "get-card-history",
  GET_REFUND_REQUESTS: "get-refund-requests",
  GET_WITHDRAWALS: "get-withdrawals",
  GET_WITHDRAWAL_SUMMARY: "get-withdrawal-summary",
  GET_CARD_PAYMENT_SETTINGS: "get-card-payment-settings",

  // Bog'lanish pochtasi
  GET_CONTACT_MESSAGES: "get-contact-messages",
  GET_CONTACT_MESSAGE: "get-contact-message",
  GET_CONTACT_STATS: "get-contact-stats",

  // Kurs chiqindi qutisi / tahrirlar izi
  GET_DELETED_COURSES: "get-deleted-courses",
  GET_COURSE_HISTORY: "get-course-history",

  // Analitika
  GET_ANALYTICS_OVERVIEW: "get-analytics-overview",
  GET_ANALYTICS_REVENUE: "get-analytics-revenue",
  GET_ANALYTICS_TIMELINE: "get-analytics-timeline",

  // Hisobotlar
  GET_TEACHER_REPORTS: "get-teacher-reports",
  GET_TEACHER_REPORT: "get-teacher-report",
  GET_STUDENT_REPORTS: "get-student-reports",
  GET_STUDENT_REPORT: "get-student-report",
  GET_COURSE_REPORTS: "get-course-reports",
  GET_COURSE_FUNNEL: "get-course-funnel",
  GET_COHORTS: "get-cohorts",
  GET_PAYOUTS: "get-payouts",
  GET_GRADE_CHANGES: "get-grade-changes",
  GET_STUDENT_NOTES: "get-student-notes",
  GET_AT_RISK: "get-at-risk",
  GET_MODERATOR_REPORT: "get-moderator-report",
  GET_MY_MODERATION_REPORT: "get-my-moderation-report",
  GET_MODERATION_ACTIONS: "get-moderation-actions",
  GET_ACTIVITY: "get-activity",
  GET_PLATFORM_SETTINGS: "get-platform-settings",
  GET_AI_MODELS: "get-ai-models",
  GET_AI_SETTINGS: "get-ai-settings",
  GET_AI_USAGE: "get-ai-usage",
  GET_AI_PUBLIC_FEATURES: "get-ai-public-features",
  GET_AI_PRECHECK: "get-ai-precheck",
  GET_AI_FLAGS: "get-ai-flags",
  GET_RISK_RULES: "get-risk-rules",
  GET_USER_CONTACTS: "get-user-contacts",
};
